import { Link } from "react-router-dom"
import { useTitle } from "../Hooks/useTitle";
import PageNotFoundImage  from "../assets/images/pagenotfound.png"

export const PageNotFound = () => {
    useTitle('Page Not Found');
    
    
    return (
        <main>
            <section  className="flex flex-col justify-center px-2">
                <div className="flex flex-col items-center my-4">
                    <p className="text-7xl text-gray-700 font-bold my-10 dark:text-white">404, Oops!</p>
                    <div className="max-w-lg">
                        <img className="rounded" src={PageNotFoundImage} alt="Oop!, Page Not Found!"/>
                    </div>
                </div>
                <div className="flex justify-center my-4">
                    <Link to='/'>
                        <button className="w-64 text-xl bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 px-5 py-2.5 mr-2 mb-2 rounded-lg font-medium dark:text-white">Back Home</button>
                    </Link>
                </div>
            </section>
        </main>
    )
}
